import { defineMessages } from 'react-intl';
export default defineMessages({
  actioncannotSameWithOldPN: {
    id: 'action.cannotSameWithOldPN',
    defaultMessage: '新手机号不能和原始手机号相同',
  },
  actionmodifyPNFailed: {
    id: 'action.modifyPNFailed',
    defaultMessage: '修改手机号失败',
  },
  actionmodifyPNSuccess: {
    id: 'action.modifyPNSuccess',
    defaultMessage: '修改手机号成功',
  },
  actiongetOrderInfoFailed: {
    id: 'action.getOrderInfoFailed',
    defaultMessage: '获取订单信息失败...',
  },
  actiongetVipInfoFailed: {
    id: 'action.getVipInfoFailed',
    defaultMessage: '获取会员信息失败...',
  },
  actiongetUserAddressFailed: {
    id: 'action.getUserAddressFailed',
    defaultMessage: '获取用户地址信息失败...',
  },
  actiongetUserAddressListFailed: {
    id: 'action.getUserAddressListFailed',
    defaultMessage: '获取用户地址列表信息失败...',
  },
  actionconfirmTakeoutAddress: {
    id: 'action.confirmTakeoutAddress',
    defaultMessage: '外卖下单确认地址...',
  },
  actionsubmitOrderInfoFailed: {
    id: 'action.submitOrderInfoFailed',
    defaultMessage: '提交订单信息失败',
  },
  actiongetVerifyCode: {
    id: 'action.getVerifyCode',
    defaultMessage: '获取验证码',
  },
  actiongetMoreGoodsFailed: {
    id: 'action.getMoreGoodsFailed',
    defaultMessage: '获取多商品优惠信息失败',
  },
  actionLocating: {
    id: 'action.Locating',
    defaultMessage: '正在定位',
  },
  actioncityLocating: {
    id: 'action.cityLocating',
    defaultMessage: '城市定位中...',
  },
  actionlocateFailed: {
    id: 'action.locateFailed',
    defaultMessage: '定位失败，请手动选择地址',
  },
  actionlocateTimeOut: {
    id: 'action.locateTimeOut',
    defaultMessage: '定位超时...',
  },
  actionlocateFailedAndRefresh: {
    id: 'action.locateFailedAndRefresh',
    defaultMessage: '定位失败，请打开手机GPS并刷新页面重试',
  },
  actionuserRefuseGetLocation: {
    id: 'action.userRefuseGetLocation',
    defaultMessage: '用户拒绝获取地理位置...',
  },
  actionuserGetLocationTimeout: {
    id: 'action.userGetLocationTimeout',
    defaultMessage: '用户获取地理位置超时...',
  },
  actionloadingGoodsList: {
    id: 'action.loadingGoodsList',
    defaultMessage: '加载商品列表中...',
  },
  actioncannotFindOrderId: {
    id: 'action.cannotFindOrderId',
    defaultMessage: '找不到订单号',
  },
  actiongetBookInfoFailedAndRefresh: {
    id: 'action.getBookInfoFailedAndRefresh',
    defaultMessage: '预定信息获取失败，请刷新重试！！',
  },
  actiongetOrderDetailFailed: {
    id: 'action.getOrderDetailFailed',
    defaultMessage: '订单详情获取失败',
  },
  actioncancelOrderFailed: {
    id: 'action.cancelOrderFailed',
    defaultMessage: '订单取消失败',
  },
  actiongetCouponSuccess: {
    id: 'action.getCouponSuccess',
    defaultMessage: '优惠券领取成功',
  },
  actiongetBookInfoFailed: {
    id: 'action.getBookInfoFailed',
    defaultMessage: '预订信息获取失败',
  },
  actioncannotGetQueueId: {
    id: 'action.cannotGetQueueId',
    defaultMessage: '未能获取到排队ID...',
  },
  actiongetQueueInfoFailed: {
    id: 'action.getQueueInfoFailed',
    defaultMessage: '获取排队信息失败',
  },
  actioncancellingQueue: {
    id: 'action.cancellingQueue',
    defaultMessage: '取消排队中...',
  },
  actioncancelQueueSuccess: {
    id: 'action.cancelQueueSuccess',
    defaultMessage: '取消排队成功',
  },
  actiongetInfoFailed: {
    id: 'action.getInfoFailed',
    defaultMessage: '获取信息失败...',
  },
  actioncannotOrderCurrent: {
    id: 'action.cannotOrderCurrent',
    defaultMessage: '暂时不可下单...',
  },
  actiongetFullOrderDiscountFailed: {
    id: 'action.getFullOrderDiscountFailed',
    defaultMessage: '获取整单优惠信息失败...',
  },
  actiongetAlipayTradeIdFailed: {
    id: 'action.getAlipayTradeIdFailed',
    defaultMessage: '获取支付宝tradeNO失败... 请稍后重试',
  },
  actionqueueDisabled: {
    id: 'action.queueDisabled',
    defaultMessage: '暂停排队中...',
  },
  actionfixQueueInfo: {
    id: 'action.fixQueueInfo',
    defaultMessage: '请先完善排队信息...',
  },
  actionwrongWithPN: {
    id: 'action.wrongWithPN',
    defaultMessage: '手机号码有误，请重填',
  },
  actionsubmitQueueInfoFailed: {
    id: 'action.submitQueueInfoFailed',
    defaultMessage: '提交排队信息失败...',
  },
  actionverifyInfoFailed: {
    id: 'action.verifyInfoFailed',
    defaultMessage: '校验验证码信息失败...',
  },
  actioncannotGetNearShop: {
    id: 'action.cannotGetNearShop',
    defaultMessage: '定位失败，不能获取附近门店...',
  },
  actiongetNearShopInfoFailed: {
    id: 'action.getNearShopInfoFailed',
    defaultMessage: '获取附近门店信息失败...',
  },
  actioncityLocateFailed: {
    id: 'action.cityLocateFailed',
    defaultMessage: '城市定位失败',
  },
  actionnomoreStore: {
    id: 'action.nomoreStore',
    defaultMessage: '没有更多档口',
  },
  orderActionOrderMoneyUnfill: {
    id: 'orderActionOrderMoneyUnfill',
    defaultMessage: '订单金额不满足起',
  },
  orderActionDelivery: {
    id: 'orderActionDelivery',
    defaultMessage: '送',
  },
  orderActionSell: {
    id: 'orderActionSell',
    defaultMessage: '卖',
  },
  orderActionPrice: {
    id: 'orderActionPrice',
    defaultMessage: '价',
  },
  orderActionGetGoodsInfoFailed: {
    id: 'orderActionGetGoodsInfoFailed',
    defaultMessage: '获取单商品促销信息失败',
  },
});



// WEBPACK FOOTER //
// ./src/intl/messages/action/part3/index.js